import { Route, Switch, useLocation } from "react-router-dom";
import React from "react";
import {
  CREATE_TRADE_PATH,
  MARKETPLACE_PATH,
  COLLAPSED_DESKTOP_MENU,
  PORTFOLIO_ACCOUNTS_PATH,
  PORTFOLIO_ASSETS_PATH,
  WATCHLIST_PATH,
  SECURITY_SETTINGS_PATH,
  BILLING_SETTINGS_PATH,
  DASHBOARD_PATH,
  GROUP_MANAGEMENT_PATH,
  USER_SIGNALS_PATH,
  AFFILIATION_PATH,
  BASE_BOTS_PATH,
  ADMIN_TRADING_CONFIGURATION_FORM_PATH,
  MOBILE_SEARCH,
  NOTIFICATIONS_SETTINGS_PATH,
  MY_GROUPS_PATH,
  ADMIN_SIGNALS_PATH,
  ADMIN_TRADING_CONFIGURATION_PATH,
  TRADES_PATH,
} from "common/constants";
import styled from "styled-components";
import { CreateTradePageTitle } from "common/Home/CreateTradePageTitle";
import { typography } from "@shared/common/Themes/typography";
import { ONBOARDING_PATHS } from "common/constants";
import { PATH_TO_DETAILED_STEP } from "features/onboarding/common/constants";
import { ONBOARDING_STEP_TO_TITLE } from "@shared/common/constants";
import BotsPageTitle from "common/Home/BotsPageTitle";
import useMedia from "utils/hooks/useMedia";
import { useBottomNavigator } from "utils/hooks/misc";
import { selectWorkspace } from "@shared/slices/common.slice";
import { OnboardingDetailedStep } from "@shared/features/onboarding/types";
import { WorkspaceType } from "@shared/types";
import { useSelector } from "react-redux";
import { DEMO_MODE_CONNECT_EXCHANGE_PRIMARY_TITLE } from "@shared/features/onboarding/constants";

const PageTitle = () => {
  const pathname = useLocation().pathname;
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const bottomNavigatorData = useBottomNavigator();
  const workspace = useSelector(selectWorkspace);
  const isDemoWorkspace = workspace === WorkspaceType.DEMO;

  const getPortfolioRoutes = () => {
    if (bottomNavigatorData) {
      return (
        <Route
          path={[PORTFOLIO_ASSETS_PATH, PORTFOLIO_ACCOUNTS_PATH]}
          render={() => <span>Portfolio</span>}
        />
      );
    } else {
      return [
        <Route
          key="assets"
          path={PORTFOLIO_ASSETS_PATH}
          render={() => <span>Assets</span>}
        />,
        <Route
          key="accounts"
          path={PORTFOLIO_ACCOUNTS_PATH}
          render={() => <span>Accounts</span>}
        />,
      ];
    }
  };

  const title = (
    <Switch>
      <Route path={DASHBOARD_PATH} render={() => <span>Dashboard</span>} />
      <Route
        path={GROUP_MANAGEMENT_PATH}
        component={() => <span>Users Management</span>}
      />
      <Route
        path={[ADMIN_SIGNALS_PATH, USER_SIGNALS_PATH]}
        component={() => <span>Signals</span>}
      />
      {getPortfolioRoutes()}
      <Route path={MY_GROUPS_PATH} render={() => <span>My Groups</span>} />
      <Route path={CREATE_TRADE_PATH} component={CreateTradePageTitle} />
      <Route path={TRADES_PATH} render={() => <span>Trades</span>} />
      <Route
        path={[BASE_BOTS_PATH, ADMIN_TRADING_CONFIGURATION_FORM_PATH]}
        component={BotsPageTitle}
      />
      <Route
        path={WATCHLIST_PATH}
        render={() => <span>Watchlist & Markets</span>}
      />
      <Route path={MARKETPLACE_PATH} render={() => <span>Marketplace</span>} />
      <Route
        path={SECURITY_SETTINGS_PATH}
        render={() => <span>Account & Security</span>}
      />
      <Route
        path={NOTIFICATIONS_SETTINGS_PATH}
        render={() => <span>Notifications Management</span>}
      />
      <Route path={BILLING_SETTINGS_PATH} render={() => <span>Billing</span>} />
      <Route path={AFFILIATION_PATH} render={() => <span>Affiliation</span>} />
      <Route
        path={ADMIN_TRADING_CONFIGURATION_PATH}
        render={() => <span>Group Configurations</span>}
      />
      <Route
        path={ONBOARDING_PATHS}
        render={() => {
          const step = PATH_TO_DETAILED_STEP[pathname];
          const title = ONBOARDING_STEP_TO_TITLE[step];
          if (
            step === OnboardingDetailedStep.CONNECT_EXCHANGE &&
            isDemoWorkspace
          )
            return DEMO_MODE_CONNECT_EXCHANGE_PRIMARY_TITLE;
          return <span>{title}</span>;
        }}
      />
    </Switch>
  );
  return <Title $isMobile={isMobile}>{title}</Title>;
};

export default PageTitle;

const TITLE_MARGIN = 12;
const Title = styled.div<{ $isMobile: boolean }>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: ${typography.fontWeights.BOLD};
  font-size: ${(p) =>
    p.$isMobile
      ? p.theme.typography.fontSizes.L
      : p.theme.typography.fontSizes.XL};
  flex: 1;
  height: 100%;
  color: ${(p) => p.theme.colors.titleColor};
  @media (max-width: ${COLLAPSED_DESKTOP_MENU}) {
    width: calc(100% - ${TITLE_MARGIN}px);
    margin-left: ${TITLE_MARGIN}px;
  }
`;
